import { render, staticRenderFns } from "./iddIncomeStaMovieDetail.vue?vue&type=template&id=48a773ad&scoped=true"
import script from "./iddIncomeStaMovieDetail.vue?vue&type=script&lang=js"
export * from "./iddIncomeStaMovieDetail.vue?vue&type=script&lang=js"
import style0 from "./iddIncomeStaMovieDetail.vue?vue&type=style&index=0&id=48a773ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a773ad",
  null
  
)

export default component.exports